export default __webpack_public_path__ + "static/media/imageCheck.e6771ef2.png";